// Gemeinsame Konstanten und Nachrichten zwischen Browser und Server.
// Die Leinwand selbst geht als Binärnachricht (ein Byte pro Pixel = Index in PALETTE) direkt nach "init".

// Feste Farbpalette (die 16 Farben der ersten r/place-Ausgabe)
export const PALETTE = [
  '#FFFFFF', '#E4E4E4', '#888888', '#222222',
  '#FFA7D1', '#E50000', '#E59500', '#A06A42',
  '#E5D900', '#94E044', '#02BE01', '#00D3DD',
  '#0083C7', '#0000EA', '#CF6EE4', '#820080',
] as const;

export const PALETTE_NAMES = [
  'Weiss', 'Hellgrau', 'Grau', 'Schwarz',
  'Rosa', 'Rot', 'Orange', 'Braun',
  'Gelb', 'Hellgrün', 'Grün', 'Türkis',
  'Blau', 'Dunkelblau', 'Lila', 'Violett',
] as const;

/** Noch kein Pixel gesetzt (nur im Kreativ-Modus) */
export const EMPTY = 255;

export const FREE_SIZE = 256;
/** Ab diesem Anteil richtiger Pixel gilt ein Zielbild als geschafft */
export const GOAL = 0.7;

export type Mode = 'free' | 'creative';

export interface TargetInfo {
  name: string;
  /** Nummer des Bildes (ab 1) und Anzahl Bilder */
  number: number;
  count: number;
  w: number;
  h: number;
  /** Zeilenweise, ein Byte pro Pixel, EMPTY = egal */
  cells: number[];
}

export type ClientMsg =
  | { t: 'hello'; name: string; mode: Mode }
  | { t: 'mode'; mode: Mode }
  | { t: 'name'; name: string }
  | { t: 'px'; x: number; y: number; c: number }
  /** Mauszeiger in Leinwand-Koordinaten, x < 0 = Zeiger hat die Leinwand verlassen */
  | { t: 'cur'; x: number; y: number };

/** [id, name, farbe, x, y] */
export type CursorEntry = [string, string, string, number, number];

export type ServerMsg =
  | {
      t: 'init'; mode: Mode; w: number; h: number; you: string; color: string;
      target: TargetInfo | null; acc: number; solved: number;
    }
  | { t: 'px'; x: number; y: number; c: number; by: string }
  | { t: 'curs'; list: CursorEntry[] }
  | { t: 'left'; id: string }
  | { t: 'acc'; acc: number }
  | { t: 'done'; acc: number; next: string; inMs: number }
  | { t: 'online'; free: number; creative: number }
  | { t: 'err'; msg: string };

export const clamp = (v: number, lo: number, hi: number) => Math.max(lo, Math.min(hi, v));
